import { paddingNum } from "@/app/utils/Common";

export class VideoReplay {
  hkRaceDate?: string;
  raceNo?: string;
  overseasRaceIndicator?: string;
  /** 
   * Scenarios: (SQ0253-715)
   * N - No video: not to show video replay button
   * Y - Full version only: show video replay button and video can be played
   * E - Simulcast video expired: show video replay button and video cannot be played
   */
  videoPresentOrNot?: string;
  isVideoReplayOn?: boolean; // same as videoPresentOrNot != 'N'
  language?: string;

  constructor(data: IVideoReplay){
    this.hkRaceDate = data.hkRaceDate
    this.raceNo = data.raceNo
    this.overseasRaceIndicator = data.overseasRaceIndicator
    this.videoPresentOrNot = data.videoPresentOrNot
    this.isVideoReplayOn = data.isVideoReplayOn
    this.language = data.language
  }

  getVideoMiddlePath() {
    const meetingDate = this.hkRaceDate?.split("-").join("") || ''
    const venueCode = this.overseasRaceIndicator || ''
    const paddingVenueCode = `s${paddingNum(venueCode.slice(1, venueCode.length))}`
    const langType = this.language?.slice(0,3) || ''
    return `replay-full/${meetingDate.slice(0, 4)}/${meetingDate}/${paddingVenueCode}${this.raceNo}/${langType}/replay-full_${meetingDate}_${paddingVenueCode}${this.raceNo}_${langType}`
  }

  showVideoIcon() {
    return this.videoPresentOrNot && this.videoPresentOrNot !== 'N'
  }

  isExpired() {
    return this.videoPresentOrNot && this.videoPresentOrNot === 'E'
  }
}